import React from 'react'
import PropTypes from 'prop-types';

import './videoPanel.styl'
class VideoPanel extends React.Component {


    componentDidMount() {
        this.draw(this.props)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.draw(nextProps)
    }

    render() {
        let {data= false, width=100, height=100, className=false} = this.props;
        if(!data) {
            return <div className="empty"></div>
        }
        return <div className={'form video-panel' + (className ? ' ' + className : '')}>
            <iframe src={data} height={width} width={height} />
        </div>
    }
}

VideoPanel.propTypes = {
    className: PropTypes.string,
    data: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number
}

export default VideoPanel
